<template>
  <div
    v-if="event.event_status === 'soldout'"
    class="flex items-center ml-auto space-x-1 text-error-muted-foreground text-sm bg-error-muted px-3 py-1 rounded-full">
    <div class="w-2 h-2 bg-error-muted-foreground rounded-full"></div>
    <span>{{ $t("Out of stock") }}</span>
  </div>

  <div
    v-else-if="event.event_status === 'nosale'"
    class="flex items-center ml-auto space-x-1 text-info-muted-foreground text-sm bg-info-muted px-3 py-1 rounded-full">
    <div class="w-2 h-2 bg-info-muted-foreground rounded-full"></div>
    <span>{{ $t("Coming soon") }}</span>
  </div>

  <div
    v-else-if="event.event_status === 'cancelled'"
    class="flex items-center ml-auto space-x-1 text-error-muted-foreground text-sm bg-error-muted px-3 py-1 rounded-full">
    <div class="w-2 h-2 bg-error-muted-foreground rounded-full"></div>
    <span>{{ $t("N/A") }}</span>
  </div>

  <div
    v-else-if="event.event_status === 'notstarted'"
    class="flex items-center mt-auto space-x-1 text-success-muted-foreground text-sm bg-success-muted px-3 py-1 rounded-full">
    <div class="w-2 h-2 bg-success-muted-foreground rounded-full"></div>
    <span>{{ $t("In stock") }}</span>
  </div>
</template>

<script setup lang="ts">
// eslint-disable-next-line @typescript-eslint/no-explicit-any
defineProps<{ event: any }>();
</script>
